import { Injectable } from '@angular/core';
import {
  HttpClient, HttpRequest, HttpResponse,
  HttpHeaders
} from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { filter } from 'rxjs/operators/filter';

@Injectable()
export class ManagerQrExportService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Yêu cầu tạo file ZIP ảnh QR trong khoảng ngày.
   * POST /api/v1/app/qr/export-zip
   */
  exportQrImagesResponse(from_date: string, to_date: string): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = {
      from_date,
      to_date,
    };

    const req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/app/qr/export-zip`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => _r as HttpResponse<any>)
    );
  }

  exportQrImages(from_date: string, to_date: string): Observable<any> {
    return this.exportQrImagesResponse(from_date, to_date).pipe(map(_r => _r.body));
  }

  /**
   * Liệt kê các file ZIP ảnh QR đã tạo sẵn.
   * GET /api/v1/app/qr/zip-files
   */
  listQrZipFilesResponse(): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/app/qr/zip-files`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => _r as HttpResponse<any>)
    );
  }

  listQrZipFiles(): Observable<{ file: string; url: string; size: number; mtime: string }[]> {
    return this.listQrZipFilesResponse().pipe(map(_r => {
      const body = _r.body;
      if (body && body.data) {
        return body.data as any;
      }
      return body as any;
    }));
  }
}
